import * as React from 'react';
import classNames from 'classnames';
import { CoverLots } from '@/types/CoverLot';
import { getCoverLotUrls } from '@/utils/urls';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback2';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './CoverLotsComponent.module.scss';

type Props = {
    catalogId: number;
    catalogUrl?: string;
    className: string;
    coverLots: CoverLots;
    featured: boolean;
    isSEOExcluded: boolean;
    sellerId: number;
};

// these are temporary - hopefully
const customImages = {
    '146331': 'https://images.liveauctioneers.com/static/mail/images/featured/20190724_handbags.gif',
    '146504': 'https://images.liveauctioneers.com/static/mail/images/featured/20190724_stair.gif',
};

const CoverLotsComponent = ({
    catalogId,
    catalogUrl,
    className = '',
    coverLots,
    featured = false,
    isSEOExcluded = false,
    sellerId,
}: Props) => {
    const { primary, secondary1, secondary2 } = getCoverLotUrls(
        catalogId,
        coverLots,
        sellerId,
        270,
        coverLots?.results?.length === 2 ? 270 : 170,
        170,
        catalogUrl
    );

    const classes = classNames(styles['cover-lots'], className, { [styles.featured]: featured });
    const primaryImageClasses = classNames(styles['primary-img-container'], {
        [styles.singlePrimary]: coverLots?.results?.length === 1,
        [styles.doublePrimary]: coverLots?.results?.length === 2,
    });
    const secondaryImageClasses = classNames(styles['secondary-img-container'], {
        [styles.singleSecondary]: coverLots?.results?.length === 1,
        [styles.doubleSecondary]: coverLots?.results?.length === 2,
    });

    // Add a custom first image for this particular auction.
    // TODO: If we decide to do this more often we need a better way
    const primaryImageUrl = customImages[catalogId] || primary.imageSrc;
    const linkRel = isSEOExcluded ? 'nofollow' : '';

    return (
        <div className={classes}>
            <div className={styles['one-and-two-wrapper']}>
                <Link className={primaryImageClasses} rel={linkRel} route to={primary.imageHref}>
                    <ImageWithFallback
                        alt={primary.imageAlt}
                        className={styles.primary}
                        placeholder={customImages[catalogId] || primary.placeholderSrc}
                        src={primaryImageUrl}
                    />
                </Link>
                <div className={secondaryImageClasses}>
                    <Link className={styles['img-container']} rel={linkRel} route to={secondary1.imageHref}>
                        <ImageWithFallback
                            alt={secondary1.imageAlt}
                            className={styles.secondary}
                            placeholder={secondary1.placeholderSrc}
                            src={secondary1.imageSrc}
                        />
                    </Link>
                    <Link className={styles['img-container']} rel={linkRel} route to={secondary2.imageHref}>
                        <ImageWithFallback
                            alt={secondary2.imageAlt}
                            className={styles.secondary}
                            placeholder={secondary2.placeholderSrc}
                            src={secondary2.imageSrc}
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(CoverLotsComponent, isEqual);
